module.exports = __webpack_public_path__ + "static/img/partIcon05.fa0e9bba.png";